import type React from 'react';
import { BottomLeftGraphic, TopRightGraphic } from './PageWithGraphic.styles';

const PageWithGraphic: React.FC = ({ children }) => {
  return (
    <>
      <BottomLeftGraphic />
      <TopRightGraphic />
      {children}
    </>
  );
};

export default PageWithGraphic;
